import { useRouteError } from "react-router-dom"
import Button from "../components/Button"
import Cursor from "../components/Cursor"

export default function ErrorPage() {
	const error: unknown = useRouteError()
	console.error(error)

	return (
		<div
			className="flex flex-col h-full w-full lg:py-48 lg:px-48 sm:py-24 sm:px-24 py-36 px-6 font-poppins text-white gap-6"
			id="error-page"
		>
			<Cursor />
			<h1 className="md:text-9xl text-5xl font-semibold text-pink font-italic">
				404
			</h1>
			<p className="text-xl mb-6">The requested page was not found.</p>

			<div className="sm:w-64 w-full">
				<Button link="/" theme="default">
					Back
				</Button>
			</div>
		</div>
	)
}
